import { hFetch } from '@/lib/hfetch';
import type { UserTaskEntity } from './entity_types/UserTask';
import type { OneOffTaskInputPayload } from '@/components/shared/OneOffTaskInput';

export const createOneOfTaskAssignment = async (contactId: number, args: OneOffTaskInputPayload) => {
  return await hFetch<UserTaskEntity, { one_off_task: { contact_id: number; name: string; due_date?: string; assign_to_role: string; other_user_id?: number } }>({
    url: '/api/one_off_task_assignments',
    method: 'POST',
    payload: {
      one_off_task: {
        contact_id: contactId,
        name: args.name,
        due_date: args.dueDate,
        ...args.payload,
      },
    },
  });
};
